/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import DialogButton from '../../ui/utils/DialogButton';

export const ErrorDialog = injectIntl(({ titleId, messageId, values, open, onClose, intl }) => {
	const title = open && intl.formatMessage({ id: titleId, defaultMessage: 'Error' });
	const message = open && intl.formatMessage({ id: messageId, defaultMessage: 'An error occurred' }, values);

	return (
		<Dialog open={open}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent
				style={{
					margin: '20px'
				}}
			>
				<DialogContentText>{message}</DialogContentText>
			</DialogContent>
			<Divider />
			<DialogActions>
				<DialogButton margin onClick={onClose}>
					<FormattedMessage id="OK" defaultMessage="OK" />
				</DialogButton>
			</DialogActions>
		</Dialog>
	);
});

export const buildErrorInfo = (titleId, messageId, values) => ({ titleId, messageId, values });

ErrorDialog.propTypes = {
	messageId: PropTypes.string.isRequired,
	titleId: PropTypes.string.isRequired,
	values: PropTypes.object,
	open: PropTypes.bool.isRequired,
	intl: intlShape.isRequired
};
ErrorDialog.defaultProps = {
	values: undefined
};
